import React, {useEffect, useState} from "react";
import {useMediaQuery} from "@mui/material";
import "./Preview.css";
import CarouselDot from "../ProductTabs/CarouselDot/CarouselDot";
import CmsHelper, {LandingPageHelper} from "../../Utilities/CmsHelpers";
import {useCms} from "../../../context/CmsContext";

const borderColors = ["#FF5500", "#9735F1", "#0087FF", "#F3BF00"];

function Preview() {
    const isCompact = useMediaQuery("(max-width:1175px)");
    const {landingData } = useCms();
    const previewData = LandingPageHelper.getPreviewSection(landingData);

    const imgs = [];

    previewData.images && previewData.images.map((item, index) => imgs.push(
        Image(CmsHelper.getImageAttributes(item.image.data), item.alt, index)));

    const [selectedIndex, setSelectedIndex] = useState(0);
    const imageCount = imgs.length;
    const activeIndex = imageCount > 0 ? Math.min(Math.max(selectedIndex, 0), imageCount - 1) : 0;

    useEffect(() => {
        setSelectedIndex((current) => (imageCount > 0 ? Math.min(current, imageCount - 1) : 0));
    }, [imageCount]);

    return (<>
        {(!!previewData.title || !!imgs.length) &&
            <div className="preview-wrapper">
                {!!previewData.title &&
                    <div className="preview-header">
                        <img src={CmsHelper.getImagePath(previewData.logo)}
                             alt="ant1 plus preview"
                             loading="lazy"
                             decoding="async"
                             className="preview-header-logo"/>
                        <h1 className="preview-header-text">{previewData.title}</h1>
                    </div>
                }
                {!!imgs.length &&
                    <div className="preview-body">
                        {isCompact
                            ? <div className="preview-item-mobile">
                                <CarouselDot slides={imgs} active={activeIndex} onChange={setSelectedIndex}/>
                              </div>
                            : imgs.map((item, index) => (<div className="preview-body-item-wrapper" key={index}>{item.img}</div>))
                        }
                    </div>
                }
            </div>
        }
    </>);
}

function Image(imageAttributes, imageMsg, index) {
    const colorIndex = index > borderColors.length ? index % borderColors.length : index;
    const imagePath = imageAttributes?.url;
    const width = imageAttributes?.width;
    const height = imageAttributes?.height;

    return {
        img: (<div className="preview-item">
                <img className="preview-body-imgs" src={imagePath} alt={imageMsg}
                     loading="lazy"
                     decoding="async"
                     width={width}
                     height={height}
                     style={{borderColor: borderColors[colorIndex]}}/>
            </div>), id: (index++)
    };

}

export default Preview;
